import React from "react";
import { Body } from "../assets/styles/styled-components/GlobalStyles";
import { useSelector } from "react-redux";
import { Box, Grid } from "@mui/material";
import { FaBars } from "react-icons/fa";
import image from "../assets/images/me.jpeg";
import pdf from "../assets/doc/Resume_Chanantaphon_Chansuksri.pdf";

export default function About() {
  const collapsed = useSelector((state) => state.sidebar.isCollaped);

  return (
    <Body isCollapsed={collapsed}>
      <div className="homepage">
        <Box>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item xs={12} sm={6} container>
              <div className="center">
                <div>
                  <img
                    src={image}
                    width={400}
                    alt="Chanantaphon Chanuksri Profile"
                  />
                  <p>
                    Chanantaphon Chansuksri (Man)
                    <br /> 20 years old
                    <br /> Bangkok, Thailand
                  </p>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} container>
              <h1>About me, myself</h1>
              <p>
                Interested in website development and mobile development.
                Passionate in developing high quality website and mobile.
                Open-minded about learning new things to improve myself and
                enjoy working and developing software as a team. Have an
                experience in lean startup and public speaking.
              </p>
              <a
                style={{
                  color: "#BF3699",
                  fontSize: 18,
                  fontWeight: "bold",
                  cursor: "pointer",
                  textDecoration: "none",
                }}
                href={pdf}
                target={"_blank"}
                rel="noopener noreferrer"
              >
                View my resume.
              </a>
            </Grid>
          </Grid>
        </Box>
      </div>
    </Body>
  );
}
